import Button from '@/features/shared/Button';
import { Theme } from '@/utils/constants';
import React from 'react';
import { HorizontalButtonProps } from '../HorizontalButtonSet.interfaces';
import useHorizontalButtonStyles from './HorizontalButton.styles';

const HorizontalButton = ({ link, image }: HorizontalButtonProps) => {
  const classes = useHorizontalButtonStyles();
  return (
    <Button
      outlined
      className={classes.root}
      theme={Theme.dark}
      link={link}
      startIcon={<img src={image?.original?.url} alt={link?.displayText} className="button-icon" />}
    />
  );
};

export default HorizontalButton;
